import React, { useState } from "react";
import { Typography, Box, Grid, IconButton, CircularProgress } from "@mui/material";
import { DataTabs } from "../LabTabs";
import { DataGridTable } from "../Table";
import { formatNumber } from "../../Utils/utils";
import { isTestEnv } from "../../globals";
import { parse, format } from "date-fns";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import Tooltip from "@mui/material/Tooltip";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import Alert from "@mui/material/Alert";

export const ReleasedOrdersHistory = ({ releasedOrders }) => {
  isTestEnv && console.log("ReleasedOrdersHistory", releasedOrders);

  const [openPopup, setOpenPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [error, setError] = useState(null);
  const [loadingRows, setLoadingRows] = useState({});
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  const handleOpenPopup = (orderItems) => {
    isTestEnv && console.log("orderItems", orderItems);
    setSelectedOrder(orderItems);
    setOpenPopup(true);
  };

  const handleClick = async (ordname) => {
    isTestEnv && console.log("ordnameeee", ordname);
    setLoadingRows(prev => ({ ...prev, [ordname]: true }));
    try {
      const response = await execute(
        "GET",
        `${process.env.REACT_APP_BACKEND_BASE_URL}/api/financialData/getOrderItems/${ordname}`,
      );
      const orderItems = response?.map((row, index) => ({
        ...row,
        id: index,
      }));
      handleOpenPopup(orderItems);
  }
  catch(error){
    isTestEnv && console.error("error", error);
      setError(
        <Alert severity="error" onClose={() => setError(null)}>
          אירעה תקלה, אנא נסו שנית מאוחר יותר
        </Alert>
      );
  }
  finally {
    setLoadingRows(prev => ({ ...prev, [ordname]: false }));
  }
}

  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedOrder(null);
  };

  const dataGridColumns = [
    {
      field: "OrdName",
      headerName: "מספר הזמנה",
      cellClassName: "first-column",
    },
    {
      field: "CustName",
      headerName: "מספר לקוח",
    },
    {
      field: "Cdes",
      headerName: "שם לקוח",
    },
    {
      field: "TotPrice",
      headerName: "סכום",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "BranchName",
      headerName: "סניף",
    },
    {
      field: "OrdDate",
      type: "date",
      headerName: "תאריך הזמנה",
    },
    {
      field: "ReleaseDate",
      headerName: "תאריך אישור",
      type: "dateTime",
      valueFormatter: (params) => {
        if (!params) return "";
        const date = parse(params, "yyyy-MM-dd   HH:mm", new Date());
        console.log("dateeee", date, format(date, "yyyy-MM-dd HH:mm"));
        return format(date, "yyyy-MM-dd HH:mm");
      },
    },
    {
      field: "Collector",
      headerName: "אושר על ידי",
    },
    {
      field: "STATUSICON",
      headerName: "פירוט ההזמנה",
      renderCell: (params) => (
        <Tooltip title="הצג פירוט">
          <IconButton onClick={() => handleClick(params.row.OrdName)} disabled={loadingRows[params.row.OrdName]}
          >
            {loadingRows[params.row.OrdName] ? (
            <CircularProgress size={24} />
          ) : (
            <LaunchIcon />)}
          </IconButton>
        </Tooltip>
      ),
      sortable: false,
      filterable: false,
      minWidth: 100,
      flex: 0.1,
    },
  ];

  const ROrders = releasedOrders?.map((row, index) => ({
    ...row,
    id: index,
    OrdDate: row["OrdDate"] ? new Date(row["OrdDate"]) : "",
  })); 


  const columns_ORDERITEMS_SUBFORM = [
    {
      field: "PDES",
      headerName: "תאור מוצר",
    },
    {
      field: "PARTNAME",
      headerName: 'מק"ט',
    },
    {
      field: "TQUANT",
      headerName: "כמות",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "VATFLAG",
      headerName: 'מע"מ',
    },
    {
      field: "PRICE",
      headerName: "מחיר ליחידה",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "QPRICE",
      headerName: 'סה"כ מחיר',
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "VATPRICE",
      headerName: 'מחיר כולל מע"מ',
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "CODE",
      headerName: "מטבע ההזמנה",
    },
    {
      field: "TUNITNAME",
      headerName: "יח' מפעל",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "PERCENT",
      headerName: "הנחה",
      renderCell: (params) => formatNumber(params.value) + "%",
    },
  ];

  return (
    <>
      <Box
        p={3} 
        bgcolor="background.paper" 
        borderRadius={2} 
        boxShadow={3} 
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              {dataGridColumns !== "undefined" && (
                <DataTabs
                  data={ROrders}
                  columns={dataGridColumns}
                  TabKey={{ value: "BranchName", label: "סניף" }}
                />
              )}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth={false} 
        PaperProps={{
          style: {
            maxWidth: "calc(75% - 50px)", 
            maxHeight: "calc(75% - 50px)", 
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "left" }}>פרטי הזמנה</DialogTitle>
        <DialogContent>
          {selectedOrder?.length > 0 ? (
            <DataGridTable
              rows={selectedOrder || []}
              columns={columns_ORDERITEMS_SUBFORM}
            />
          ) : (
            <Typography variant="body1" color="textSecondary">
              אין פריטים להזמנה זו
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
